(function () {
  'use strict';

  /* =============================================
     Paint Calculator – DOM refs & state
     ============================================= */
  const GALLON_COVERAGE = 350;
  const QUART_COVERAGE  = 87.5;
  const SAFETY_MARGIN   = 1.10;

  let wallCounter = 0;

  function el(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  /* =============================================
     Modal open / close
     ============================================= */
  function initTriggers() {
    document.querySelectorAll('[data-paint-calc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var overlay = el('[data-paint-calc-overlay]');
        if (overlay) openModal(overlay);
      });
    });
  }

  function openModal(overlay) {
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    // Close on wash click
    var wash = el('.paint-calc-overlay__wash', overlay);
    if (wash) {
      wash.addEventListener('click', function handler() {
        closeModal(overlay);
        wash.removeEventListener('click', handler);
      });
    }

    // Close button
    var closeBtn = el('[data-paint-calc-close]', overlay);
    if (closeBtn) {
      closeBtn.addEventListener('click', function handler() {
        closeModal(overlay);
        closeBtn.removeEventListener('click', handler);
      });
    }

    // Escape key
    function escHandler(e) {
      if (e.key === 'Escape') {
        closeModal(overlay);
        document.removeEventListener('keydown', escHandler);
      }
    }
    document.addEventListener('keydown', escHandler);
  }

  function closeModal(overlay) {
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  }

  /* =============================================
     Tooltip toggle
     ============================================= */
  function initTooltip() {
    var trigger = el('[data-paint-calc-tooltip-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var tip = el('[data-paint-calc-tooltip]');
      if (tip) tip.classList.toggle('is-active');
    });

    // Close tooltip when clicking outside
    document.addEventListener('click', function (e) {
      var tip = el('[data-paint-calc-tooltip]');
      if (!tip) return;
      if (!e.target.closest('[data-paint-calc-tooltip]') && !e.target.closest('[data-paint-calc-tooltip-trigger]')) {
        tip.classList.remove('is-active');
      }
    });
  }

  /* =============================================
     Wall rows
     ============================================= */
  function escapeAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  function getWallFormI18n() {
    var form = el('[data-paint-calc-form]');
    if (!form || !form.dataset) {
      return {
        wallPrefix: 'Wall',
        widthLabel: 'Width (ft)',
        heightLabel: 'Height (ft)'
      };
    }
    return {
      wallPrefix: form.dataset.paintCalcWallPrefix || 'Wall',
      widthLabel: form.dataset.paintCalcWidthLabel || 'Width (ft)',
      heightLabel: form.dataset.paintCalcHeightLabel || 'Height (ft)'
    };
  }

  function addWallRow() {
    wallCounter++;
    var container = el('[data-paint-calc-walls]');
    if (!container) return;

    var i18n = getWallFormI18n();
    var idBase = 'paint-calc-wall-' + wallCounter;
    var idW = idBase + '-w';
    var idH = idBase + '-h';

    var row = document.createElement('div');
    row.className = 'paint-calc-wall-row';
    row.setAttribute('data-paint-calc-wall', '');
    row.innerHTML =
      '<span class="paint-calc-wall-row__label">' + i18n.wallPrefix + ' ' + wallCounter + '</span>' +
      '<div class="paint-calc-wall-row__field">' +
        '<label for="' + idW + '">' + i18n.widthLabel + '</label>' +
        '<input type="number" id="' + idW + '" data-wall-width min="0" step="0.5" inputmode="decimal" aria-label="' + escapeAttr(i18n.widthLabel) + '">' +
      '</div>' +
      '<div class="paint-calc-wall-row__field">' +
        '<label for="' + idH + '">' + i18n.heightLabel + '</label>' +
        '<input type="number" id="' + idH + '" data-wall-height min="0" step="0.5" inputmode="decimal" aria-label="' + escapeAttr(i18n.heightLabel) + '">' +
      '</div>' +
      '<button type="button" class="paint-calc-wall-row__remove" data-remove-wall aria-label="Remove wall">&times;</button>';

    container.appendChild(row);
    renumberWalls();
  }

  function removeWall(btn) {
    var row = btn.closest('[data-paint-calc-wall]');
    if (row) row.remove();
    renumberWalls();

    // Ensure at least 1 wall remains
    var walls = document.querySelectorAll('[data-paint-calc-wall]');
    if (walls.length === 0) addWallRow();
  }

  function renumberWalls() {
    var i18n = getWallFormI18n();
    var walls = document.querySelectorAll('[data-paint-calc-wall]');
    walls.forEach(function (w, i) {
      var label = el('.paint-calc-wall-row__label', w);
      if (label) label.textContent = i18n.wallPrefix + ' ' + (i + 1);
    });
  }

  function initWalls() {
    // Add-wall button
    var addBtn = el('[data-paint-calc-add-wall]');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        addWallRow();
      });
    }

    // Delegate remove clicks
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-remove-wall]')) {
        removeWall(e.target.closest('[data-remove-wall]'));
      }
    });

    // Seed first wall
    addWallRow();
  }

  /* =============================================
     Calculation
     ============================================= */
  function calculate() {
    var coatsInput = el('[data-paint-calc-coats]');
    var coats = parseInt(coatsInput ? coatsInput.value : 2, 10);
    if (isNaN(coats) || coats < 1) coats = 2;

    var totalArea = 0;
    document.querySelectorAll('[data-paint-calc-wall]').forEach(function (row) {
      var w = parseFloat(el('[data-wall-width]', row).value) || 0;
      var h = parseFloat(el('[data-wall-height]', row).value) || 0;
      totalArea += w * h;
    });

    totalArea = totalArea * coats * SAFETY_MARGIN;

    if (totalArea <= 0) return null;

    // Total quarts needed (round up)
    var totalQuarts = Math.ceil(totalArea / QUART_COVERAGE);

    // Break into gallons + remaining quarts
    var gallons = Math.floor(totalQuarts / 4);
    var quarts  = totalQuarts % 4;

    return { totalArea: totalArea, gallons: gallons, quarts: quarts };
  }

  function buildResultText(result) {
    if (!result) return '';

    var parts = [];
    if (result.gallons > 0) {
      parts.push(result.gallons + ' gallon' + (result.gallons !== 1 ? 's' : ''));
    }
    if (result.quarts > 0) {
      parts.push(result.quarts + ' quart' + (result.quarts !== 1 ? 's' : ''));
    }

    if (parts.length === 0) return '';

    return 'This project will take ' + parts.join(' and ') + ' to complete.';
  }

  function initCalculate() {
    var form = el('[data-paint-calc-form]');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var result = calculate();
      var resultEl = el('[data-paint-calc-result]');
      var textEl   = el('[data-paint-calc-result-text]');

      if (!result) {
        if (resultEl) resultEl.classList.remove('is-visible');
        return;
      }

      if (textEl) textEl.textContent = buildResultText(result);
      if (resultEl) resultEl.classList.add('is-visible');

      launchConfetti();
    });
  }

  /* =============================================
     Confetti 🎉
     ============================================= */
  function launchConfetti() {
    var canvas = document.createElement('canvas');
    canvas.className = 'paint-calc-confetti';
    document.body.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;

    var pieces = [];
    var colors = ['#ff595e','#ffca3a','#8ac926','#1982c4','#6a4c93','#ff924c'];
    var total  = 120;

    for (var i = 0; i < total; i++) {
      pieces.push({
        x: canvas.width / 2 + (Math.random() - 0.5) * 200,
        y: canvas.height / 2,
        vx: (Math.random() - 0.5) * 16,
        vy: (Math.random() - 1) * 18 - 4,
        w: Math.random() * 8 + 4,
        h: Math.random() * 6 + 2,
        color: colors[Math.floor(Math.random() * colors.length)],
        rotation: Math.random() * 360,
        rotSpeed: (Math.random() - 0.5) * 12,
        gravity: 0.35 + Math.random() * 0.15,
        opacity: 1
      });
    }

    var startTime = Date.now();
    var duration  = 2500;

    function frame() {
      var elapsed = Date.now() - startTime;
      if (elapsed > duration) {
        canvas.remove();
        return;
      }

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      pieces.forEach(function (p) {
        p.x  += p.vx;
        p.vy += p.gravity;
        p.y  += p.vy;
        p.rotation += p.rotSpeed;
        p.opacity = Math.max(0, 1 - elapsed / duration);

        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate((p.rotation * Math.PI) / 180);
        ctx.globalAlpha = p.opacity;
        ctx.fillStyle = p.color;
        ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      });

      requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  /* =============================================
     Bootstrap
     ============================================= */
  function init() {
    initTriggers();
    initTooltip();
    initWalls();
    initCalculate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
